import autobind from 'autobind-decorator';
import * as React from 'react';

import { BillingPeriodUnit } from '../../../../../units/subscription/enums/billing-period-unit';
import { SubscriptionAddon } from '../../../interfaces/subscription-addon';
import { Addon } from './addon/addon';
import { ANNOTATIONS_ADV_DIALOG_NAME } from './addon/annotations-adv-dialog';
import { AUTO_MEASURE_ADV_DIALOG_NAME } from './addon/auto-measure-adv-dialog';
import { TEMPLATES_ADV_DIALOG_NAME } from './addon/templates-adv-dialog';
import { Styled } from './styled';

type AddonGroupName = 'Auto Measure' | 'Annotation Tools' | 'Templates for Projects';
export type AddonAdvDialogName =
  typeof AUTO_MEASURE_ADV_DIALOG_NAME |
  typeof ANNOTATIONS_ADV_DIALOG_NAME |
  typeof TEMPLATES_ADV_DIALOG_NAME;

const addonGroupNameToAdvDialogName: Record<AddonGroupName, AddonAdvDialogName> = {
  'Auto Measure': AUTO_MEASURE_ADV_DIALOG_NAME,
  'Annotation Tools': ANNOTATIONS_ADV_DIALOG_NAME,
  'Templates for Projects': TEMPLATES_ADV_DIALOG_NAME,
};

interface Props {
  availableAddons: SubscriptionAddon[];
  selectedAddonIds: string[];
  onSelectedAddonIdsChange: (selectedAddons: string[]) => void;
  isTeamPlan: boolean;
  billingPeriod: BillingPeriodUnit;
}

export class AddonList extends React.Component<Props> {
  public render(): JSX.Element {
    const { selectedAddonIds: selectedAddons, availableAddons } = this.props;
    const selectedAddonIdsMap = new Set(selectedAddons);

    return (
      <Styled.Container>
        {
          availableAddons
            .filter(addon => addon.isSelfService)
            .map(addon => this.renderAddon(addon, selectedAddonIdsMap.has(addon.id)))
        }
      </Styled.Container>
    );
  }

  @autobind
  private renderAddon(addon: SubscriptionAddon, isSelected: boolean): JSX.Element {
    return (
      <Addon
        addon={addon}
        isSelected={isSelected}
        isTeamPlan={this.props.isTeamPlan}
        advDialogName={addonGroupNameToAdvDialogName[addon.groupName]}
        toggleSelection={this.toggleSelection}
        billingPeriod={this.props.billingPeriod}
      />
    );
  }

  @autobind
  private toggleSelection(id: string, isSelected: boolean): void {
    const selectedAddonIds = isSelected
      ? this.props.selectedAddonIds.concat(id)
      : this.props.selectedAddonIds.filter(x => x !== id);

    this.props.onSelectedAddonIdsChange(selectedAddonIds);
  }
}
